import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MxNavigationBarActions } from "../store/ducks/components/NavigationBar/navigationBar";

/**
 * @typedef {Object} Options
 * @property {boolean} [limparAposUso]
 * @property {any[]} [deps=[]]
 *
 * @typedef {() => void} Callback Callback passado para o botão de voltar
 */
/**
 * Hook usado para atualizar o callback do botão de voltar da barra de navegação
 *
 * O callback é sempre limpo quando o componente é desmontado
 * @param {Callback} cb 
 * @param {Options} options

 *
 */
export function useUpdateOnGoBack(cb, options = {}) {
    const { limparAposUso, deps } = Object.assign(
        {},
        {
            limparAposUso: true,
            deps: [cb]
        },
        options
    );

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(
            MxNavigationBarActions.onGoBack(cb, {
                limparAposUso: limparAposUso
            })
        );
        return () => {
            dispatch(MxNavigationBarActions.resetOnGoBack());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
